import { ILogAdapterService } from './log-adapter.interface';
import { IMonitoringBody } from '../../../interfaces';
import { injectable } from 'inversify';

@injectable()
export class LogAdapterMock implements ILogAdapterService {
    send(logs: IMonitoringBody): void {
        // We need to use the console in this case because we want to
        // display the logs send to the AlkLogger.
        console.debug('[LogAdapterMock#send]', logs);
    }
}
